import axios from 'axios'
import qs from 'qs'

// 创建一个axios实例
const axios_instance = axios.create()

// 设置axios拦截器：请求拦截器
axios_instance.interceptors.request.use(config => {
  let domain = window.location.host.indexOf("localhost") > -1 ? 'http://localhost:8080' : 'https://workflow.premia-partners.com';
  config.baseURL = domain + "/user-api";
  let token = localStorage.getItem("token");
  if (config.data) {
    config.data["x-token"] = token;
  } else {
    config.data = {"x-token" : token};
  }
  config.data = qs.stringify(config.data);
  return config
}, err => {
  // 请求未成功发出，如：没有网络...
  console.log("err===="+err);
  return Promise.reject(err)
})

const AXIOS = async function(url, data) {
  let result = {};
  await axios_instance({
      url: url,
      method: "POST",
      data: data ? data : null,
  }).then(function (response) {
      if (response.status == 200) {
          result = response.data;
      } else {
          console.log("AXIOS " + url + " failed, reponse code: " + response.status);
          result.errMsg = "AXIOS " + url + " failed, reponse code: " + response.status;
          result.success = false;
      }
  }).catch(function(error) {
      console.log("AXIOS " + url + " failed, error: " + error);
      result.errMsg = "AXIOS " + url + " failed, error: " + error;
      result.success = false;
  })
  return result;
}

export default AXIOS
